import { createSelector } from 'reselect';
import { IRAAutoMaxSubmissionPayload } from '.';
import { getBankSelection } from '../../bankSelection';
import {
  AutoMaxContributionOptions,
  IRAAutoMaxCalculationData,
} from '../IRAAutoMaxCalculation';
import { getIRAAutoMaxCalculationData } from '../IRAAutoMaxCalculation/IRAAutoMaxCalculations.selectors';
import { getAutomaxContributionOptions } from '../IRAAutoMaxCalculation/IRAAutoMaxCalculations.selectors';

export const getIRAAutoMaxSubmissionPayload = createSelector(
  [
    getIRAAutoMaxCalculationData,
    getAutomaxContributionOptions,
    getBankSelection,
  ],
  (
    iraAutoMaxCalculationData: IRAAutoMaxCalculationData,
    autoMaxContributionOptions: AutoMaxContributionOptions,
    bankSelection
  ): IRAAutoMaxSubmissionPayload | null => {
    const { contributions, maxContributionLimit } = iraAutoMaxCalculationData;
    return {
      autoMaxContributionOptions,
      autoMaxContributionSchedule: {
        contributions,
        maxContributionLimit,
      },
      bankDto: {
        bankAgreementID: bankSelection?.selectedBank?.bankAgreementID || '',
      },
    };
  }
);
